import React from 'react';
import './LoadingSpinner.css';

export default function LoadingSpinner({ message = 'Loading data…' }) {
  return (
    <div className="spinner-wrap" role="status" aria-live="polite">
      <div className="spinner" aria-hidden="true" />
      <p className="spinner-msg">{message}</p>
      <span className="sr-only">Loading</span>
    </div>
  );
}
